import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
const supabaseAuthEnabled = process.env.REACT_APP_ENABLE_SUPABASE_AUTH !== 'false';

export const isSupabaseConfigured = Boolean(
  supabaseAuthEnabled && supabaseUrl && supabaseAnonKey
);

export const supabase = isSupabaseConfigured
  ? createClient(supabaseUrl, supabaseAnonKey)
  : null;
